import React from "react";
import { Avatar, AvatarProps } from "@mui/material";
import { UserResponse } from "../../api-data/iam/user";

type InitialsSource = Pick<
  UserResponse,
  "firstName" | "lastName" | "phoneNumber"
> | null;

const getInitials = (user: InitialsSource) => {
  if (user?.firstName) {
    return `${user.firstName[0]}${user.lastName ? user.lastName[0] : ""}`.toUpperCase();
  }
  if (user?.phoneNumber) {
    return String(user.phoneNumber).slice(-2);
  }
  return "U";
};

interface UserAvatarProps extends Omit<AvatarProps, "children"> {
  user: InitialsSource;
}

/** Amber-on-teal initials avatar — shared between the header and account pages. */
const UserAvatar: React.FC<UserAvatarProps> = ({ user, sx, ...props }) => (
  <Avatar
    sx={{
      bgcolor: "secondary.main",
      color: "primary.dark",
      fontWeight: 700,
      ...sx,
    }}
    {...props}
  >
    {getInitials(user)}
  </Avatar>
);

export default UserAvatar;
